class BackInStock extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = [...document.querySelectorAll('.js-bis-toggle')];
    this.form = this.querySelector('.js-bis-form');
    this.errorContainer = this.querySelector('.js-back-in-stock__error');
  }

  connectedCallback() {
    this._attachEvents();
  }

  _attachEvents() {
    if (this.form) {
      this.form.addEventListener('submit', this.submitForm.bind(this));
    }

    if (this.toggleBtn.length > 0) {
      this.toggleBtn.forEach((btn) => {
        btn.addEventListener('click', this.toggleModal.bind(this));
      });
    }
  }

  submitForm(evt) {
    evt.preventDefault();

    const formData = new FormData(this.form);
    const url = this.form.getAttribute('action');

    fetch(url, {
      method: 'POST',
      body: formData,
    })
    .then((response) => response.json())
    .then(response => {
      if (response.success) {
        this.classList.remove('bis-form--error');
        this.errorContainer.innerHTML = ''
        this.classList.add('bis-form--success');
        this.form.reset();
      } else {
        this.classList.add('bis-form--error');
        this.errorContainer.innerText = response.message;
      }
    });
  }

  toggleModal() {
    setTimeout(() => {
      this.classList.remove('bis-form--error');
      this.classList.remove('bis-form--success');
    }, 500);

    this.classList.toggle('is-visible');
  }
}

customElements.define('back-in-stock', BackInStock);
